import { CONTRACT_TYPES, CONTRACT_STATUS, CONTRACT_TYPE_CONFIG, STATUS_BADGE_CONFIG, CONTRACT_TYPE_STATUS_OVERRIDES } from "@/constants/contracts";
export const getContractStatus = (expiryDate)=>{
    const expiry = new Date(expiryDate);
    const now = new Date();
    if (expiry < now) return CONTRACT_STATUS.EXPIRED;
    if (expiry > now) return CONTRACT_STATUS.ACTIVE;
    return CONTRACT_STATUS.PENDING;
};
export const getDaysRemaining = (expiryDate)=>{
    const expiry = new Date(expiryDate);
    const now = new Date();
    const diffTime = expiry.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};
export const getExpiryLabel = (contractType)=>{
    if (!contractType) return CONTRACT_TYPE_CONFIG[CONTRACT_TYPES.DIRECT].expiryLabel;
    return CONTRACT_TYPE_CONFIG[contractType]?.expiryLabel || 'Expires';
};
export const getContractTypeBadgeConfig = (contractType)=>{
    if (!contractType) return null;
    const config = CONTRACT_TYPE_CONFIG[contractType];
    if (!config) return null;
    return {
        label: config.label,
        className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.badgeColor.bg} ${config.badgeColor.text}`
    };
};
export const getStatusBadgeConfig = (status, contractType)=>{
    if (contractType) {
        const typeOverrides = CONTRACT_TYPE_STATUS_OVERRIDES[contractType];
        if (typeOverrides) {
            const override = typeOverrides[status];
            if (override) {
                return {
                    label: override.label,
                    className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${override.color.bg} ${override.color.text}`
                };
            }
        }
    }
    const config = STATUS_BADGE_CONFIG[status];
    if (!config) return null;
    return {
        label: config.label,
        className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color.bg} ${config.color.text}`
    };
};
export const shouldShowDaysRemaining = (contractType, status)=>{
    if (!contractType || status !== CONTRACT_STATUS.ACTIVE) return false;
    return CONTRACT_TYPE_CONFIG[contractType].showDaysRemaining;
};
export const shouldShowWarning = (contractType, daysRemaining)=>{
    if (!contractType || daysRemaining === undefined) return false;
    const threshold = CONTRACT_TYPE_CONFIG[contractType].warningThresholdDays;
    if (threshold === undefined) return false;
    return daysRemaining <= threshold;
};
export const isLicensedContract = (contract)=>{
    return !!contract.license_terms;
};
export const isLicensedProduct = (product)=>{
    return product?.Metadata?.contractModel === 'LICENSED_CLUSTER';
};
